import React from "react";
import { Reveal } from "./motion/Reveal";
import StarField from "./StarField";
import AngelWings from "./AngelWings";

export default function Close() {
    return (
        <section className="relative py-24 sm:py-32 bg-alma-white overflow-hidden">
            <StarField count={20} />
            <div className="absolute top-0 left-1/2 -translate-x-1/2 h-80 w-80 rounded-full bg-alma-goldSoft/40 blur-3xl" aria-hidden />
            <div className="relative max-w-[800px] mx-auto px-6 sm:px-8 text-center">
                <Reveal>
                    <div className="flex justify-center mb-6">
                        <AngelWings className="w-[180px] sm:w-[220px] h-auto opacity-90" />
                    </div>
                    <p className="font-sans text-lg text-alma-slate leading-relaxed max-w-xl mx-auto">
                        Quizá no sea casualidad que hayas llegado hasta aquí. Si sientes que necesitas un lugar
                        donde cuidar tu alma, compartir tu camino y sentirte acompañada, Alquimia del Alma puede
                        ser ese hogar que estabas buscando.
                    </p>
                    <a
                        href="#precios"
                        data-testid="final-cta"
                        className="group relative mt-10 inline-flex items-center justify-center rounded-full bg-gradient-to-r from-alma-gold to-alma-goldDeep text-alma-ink h-14 px-9 text-base font-semibold shadow-lg shadow-alma-gold/30 overflow-hidden"
                    >
                        <span className="absolute inset-0 bg-alma-ink translate-y-full group-hover:translate-y-0 transition-transform duration-500" />
                        <span className="relative group-hover:text-alma-white transition-colors">
                            Sí, quiero formar parte de esta familia
                        </span>
                    </a>
                </Reveal>
            </div>
        </section>
    );
}
